import React from 'react';
import PropTypes from 'prop-types';
import Yup from 'yup';
import {
  TextField,
  Button,
  Modal,
  ModalButtons,
  ModalContent,
  ProgressBar,
  withForm,
} from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import { SHOW_NOTIFY, NOTIFY_LEVEL } from 'constants';
import {
  UPDATE_GRAPH_FOLDER,
  MANAGE_GRAPH_FOLDER,
} from '@control-front-end/common/constants/graphFolders';
import useIntl from 'useIntl';
import mes from './intl';
import LayersMultiselect from './components/LayersMultiselect';
// eslint-disable-next-line no-unused-vars
import m from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import l from './ManageGraphFolder.scss'; // NOSONAR

function ManageGraphFolderBase(props) {
  const {
    data,
    values,
    handleSubmit,
    handleOnChange,
    visibility,
    onClose,
    isSubmit,
    errors,
  } = props;
  const t = useIntl();

  return (
    <Modal
      styleName="m.modal"
      onClose={onClose}
      label={t(mes.editGraph)}
      visibility={visibility}
    >
      <ModalContent styleName="m.modal__content">
        <div styleName="l.block">
          <TextField
            id="name"
            styleName="m.textfield"
            autoFocus={true}
            autoSelect={true}
            bordered={true}
            size="large"
            label={t(mes.name)}
            value={values.name}
            error={!!errors.name}
            helperText={t(mes[errors.name])}
            onChange={handleOnChange}
            visibility={data.manageLayers ? 'hidden' : 'visible'}
          />
        </div>
        <div styleName="l.block">
          <LayersMultiselect
            id="layers"
            size="large"
            label={t(mes.addLayers)}
            value={values.layers}
            exclude={data.exclude}
            onChange={handleOnChange}
          />
        </div>
      </ModalContent>
      <ModalButtons styleName="m.modal__buttons">
        <Button
          label={t(mes.save)}
          size="large"
          onClick={handleSubmit}
          visibility={isSubmit ? 'disabled' : 'visible'}
        />
        <ProgressBar
          styleName="m.modal__loader"
          type="circle"
          size="small"
          visibility={isSubmit ? 'visible' : 'hidden'}
        />
      </ModalButtons>
    </Modal>
  );
}

ManageGraphFolderBase.propTypes = {
  visibility: PropTypes.bool,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  isSubmit: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  data: PropTypes.object,
};

const ManageGraphFolder = withForm(
  {
    mapPropsToValues(props) {
      const formData = props.data || {};
      return {
        name: formData.name || 'New graph',
        layers: [],
      };
    },
    yup: Yup.object().shape({
      name: Yup.string().min(2).required('field_required'),
    }),
    handleSubmit: (values, dispatch, formActions, props) => {
      const { name, layers } = values;
      const { id, name: prevName } = props.data;
      const manageLayers = () => {
        const actions = layers.length
          ? layers.filter(({ action }) => !!action)
          : [];
        // если изменялись слои, добавляем в граф
        if (actions.length) {
          dispatch({
            type: MANAGE_GRAPH_FOLDER.REQUEST,
            payload: { id, actions },
            callback: () => {
              if (props.callback) props.callback({ id, actions });
              props.onClose();
            },
          });
        } else {
          props.onClose();
        }
      };

      if (name === prevName) {
        manageLayers();
        return;
      }
      dispatch({
        type: UPDATE_GRAPH_FOLDER.REQUEST,
        payload: { id, name },
        callback: () => {
          manageLayers();
          dispatch({
            type: SHOW_NOTIFY.REQUEST,
            payload: {
              id: AppUtils.createRid(),
              type: NOTIFY_LEVEL.SUCCESS,
              label: 'Graph has been successfully updated',
            },
          });
        },
      });
    },
  },
  ManageGraphFolderBase
);

export default ManageGraphFolder;
